import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MapperService} from '../../../services/mapper.service';

@Component({
    selector: 'app-title.dialog',
    templateUrl: './title.dialog.component.html',
    standalone: false
})
export class TitleDialogComponent {

  plan;
  title;
  isLoading = false;

  constructor(
    public mapperService: MapperService,
    public dialogRef: MatDialogRef<TitleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      plan
    },
  ) {
    this.plan = data.plan;
    this.title = data.plan.title;
  }

  save(): void {
    this.isLoading = true;

    this.mapperService.updatePlan({
      ...this.plan,
      title: this.title
    }).subscribe((res) => {
      this.isLoading = false;

      if (res.updated) {
        this.dialogRef.close(res.updated);
      }
    }, () => {
      this.isLoading = false;
    });
  }
}
